import * as React from 'react';
import styled from 'styled-components';

import { TertiaryButton } from '@longline/aqua-ui/controls/TertiaryButton';
import { InfoBox } from '@longline/aqua-ui/containers/InfoBox';
import { TabBar } from '@longline/aqua-ui/controls/TabBar';
import { Icon } from '@longline/aqua-ui/controls/Icon';

import { useGlobalState } from '../../contexts/state/GlobalStateContext';
import { AreaInfoBoxHeader } from './AreaInfoBoxHeader';
import { IArea } from '../../types/IArea';
import { AreaTab } from './tabs/AreaTab';
import { Sprites } from '../../svg';
import { SimulateTab } from './tabs/SimulateTab';
import { DriverTab } from './tabs/DriverTab';
import { Scroller } from '../../ui/Scroller';
import { Can } from '../../ui/Can';

interface IProps {
  value?: IArea;
}

const AreaInfoBox = (props: IProps) => {
  const globalState = useGlobalState();

  const [tab, setTab] = React.useState<'settings' | 'drivers' | 'simulate'>('settings');

  // Optional because <ListView aux> injects the active item; render nothing
  // if no item is selected.
  if (!props.value) return null;
  const area = props.value;

  const canSimulate = () => {
    if(globalState.organix != null) return false;
    if(!area.driverset) return false;
    if(!globalState.hasBathymetry()) return false;
    if(!globalState.hasCurrentSpeed()) return false;
    return true;
  }

  const getStatus = () => {
    if(!area.driverset) return (<Status>
      <Icon url={Sprites.Icons.Warning}/> No driver set selected.
    </Status>);
    if(!globalState.hasBathymetry()) return (<Status>
      <Icon url={Sprites.Icons.Warning}/> No bathymetry data available.
    </Status>);
    if(!globalState.hasCurrentSpeed()) return (<Status>
      <Icon url={Sprites.Icons.Warning}/> No current velocity data available.
    </Status>);
    return null;
  }

  const handleSimulate = () => {
    globalState.setMode('area-editor');
    globalState.setSelectedArea(area);
    globalState.startOrganix(area)
  }

  const getFooter = () => {
    return (
      <>
        <TertiaryButton onClick={() => globalState.focusArea(area)}>FOCUS</TertiaryButton>
        <Can permission="simulate">
          <TertiaryButton disabled={!canSimulate()} onClick={handleSimulate}>
            {globalState.organix != null ? "SIMULATING" : "SIMULATE"}
          </TertiaryButton>
        </Can>
      </>
    )
  }

  return (
    <InfoBox 
      header={<AreaInfoBoxHeader value={area} withClose/>}
      width={300}
      footer={getFooter()}
    >
      <div style={{backgroundColor: '#333'}}>
        <TabBar size="small" line>
          <TabBar.Tab onClick={() => setTab('settings')}>Settings</TabBar.Tab>
          <TabBar.Tab onClick={() => setTab('drivers')}>Drivers</TabBar.Tab>
          <TabBar.Tab onClick={() => setTab('simulate')}>Simulation</TabBar.Tab>
        </TabBar>
      </div>

      <Scroller padded height="calc(100vh - 220px)">
        {tab === 'settings' && <AreaTab value={area}/>}
        {tab === 'drivers' && <DriverTab value={area}/>}
        {tab === 'simulate' && <SimulateTab value={area}/>}
     </Scroller>

      {getStatus()}
    </InfoBox>
  )
}

const Status = styled.div`
  background-color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;  
  padding: 4px 0 4px 0;
`

export { AreaInfoBox }

